import { currencyFormat } from 'common/helpers/numberHelper';

const Taxes = (props) => {
  const { taxes, settings } = props;
  if (!taxes) {
    return null;
  }
  const taxNotInclude = taxes.filter((tax) => tax.isIncludedInPrice === false);
  return (
    <>
      {taxNotInclude.map((tax) => (
        <div key={tax.id}>
          <div>{tax.title}:</div>
          <div>{currencyFormat(tax.price, settings)}</div>
        </div>
      ))}
    </>
  );
};

export default Taxes;
